import { useImmer, ImmerHook } from 'use-immer';
import isEqual from 'lodash/isEqual';

export type StateForm<S = any> = {
    data: ImmerHook<S>[0];
    setValue: ImmerHook<S>[1];
    get<Field extends keyof S>(field: Field): S[Field];
    set<Field extends keyof S>(field: Field, value: S[Field]): void;
    onChangeHandlerFor<Field extends keyof S>(field: Field): (value: S[Field]) => void;
    getXSInputProps<Field extends keyof S>(
        field: Field,
    ): {
        value: S[Field];
        onChange(value: S[Field]): void;
    };
    changed(): boolean;
    reset(): void;
    /**
     * @deprecated. use: "data"
     */
    value: ImmerHook<S>[0];
};

export function useStateForm<S = any>(initialValue: S): StateForm<S> {
    const [state, setState] = useImmer(initialValue);

    return {
        value: state,
        data: state,
        setValue: setState,
        get: (field) => state[field],
        set(field, value) {
            setState((state) => {
                state[field as any] = value;
            });
        },
        onChangeHandlerFor: (field) => (value) => {
            setState((state) => {
                state[field as any] = value;
            });
        },
        getXSInputProps(field) {
            return {
                value: state[field],
                onChange(value) {
                    setState((state) => {
                        state[field as any] = value;
                    });
                },
            };
        },
        changed: () => !isEqual(initialValue, state),
        reset: () => setState(() => initialValue),
    };
}
